import React from 'react';
import {Card} from "primereact/card";
import {Avatar} from "primereact/avatar";

function CardViewTitleDescriptionIconValue(props) {
    return (
        <div className="w-full lg:flex-1">
            <div className={`p-2 border-round-3xl surface-card border-1 border-gray-300 h-full flex flex-column hover-shadow-card justify-content-center`}>
                <div className="flex gap-2 align-items-center p-3">
                    <div className="w-full flex flex-column text-xs flex-1 gap-2">
                        <span className="text-md text-600">{props.title}</span>
                        <div className="flex gap-2 align-items-baseline">
                            {props.value&&<span className="text-4xl font-bold">{props.value}</span>}
                            {props.badge&&<span className="bg-gray-200 border-round-lg font-bold pl-2 pr-2 text-primary text-center">{props.badge}</span>}
                        </div>
                    </div>
                    {props.icon&&(<Avatar size="large" className="w-3rem h-3rem surface-100" icon={props.icon}/>)}
                </div>
                {/*<div className="flex justify-content-center align-items-center flex-1">*/}
                {/*    {props.children}*/}
                {/*</div>*/}
            </div>
        </div>
    );
}

export default CardViewTitleDescriptionIconValue;